(function () {
	function jsonTabs() {
		const containers = document.querySelectorAll('.ee-tabs-plus');

		containers.forEach((container) => {
			const buttons = container.querySelectorAll('.tab-buttons button.tab-button');
			const contentContainers = container.querySelectorAll('.tab-content');
			const activeBtn = container.querySelector('.tab-buttons button.tab-button[aria-selected="true"]');
			const btnsContainer = container.querySelector('.buttons-container');

			// Afisare buton activ
			if (activeBtn && btnsContainer) {
				const buttonRect = activeBtn.getBoundingClientRect();
				const containerRect = btnsContainer.getBoundingClientRect();
				btnsContainer.scrollLeft += buttonRect.left + buttonRect.width / 2 - (containerRect.left + containerRect.width / 2);
			}

			// Handle tabs
			buttons.forEach((button) => {
				button.addEventListener('click', (e) => {
					e.preventDefault();

					button.setAttribute('aria-selected', 'true');
					button.setAttribute('tabindex', '0');

					[...buttons]
						.filter((b) => b !== button)
						.forEach((b) => {
							b.setAttribute('aria-selected', 'false');
							b.setAttribute('tabindex', '-1');
						});

					// Handle tab content
					const contentContainer = container.querySelector(`#${button.getAttribute('aria-controls')}`);
					contentContainer?.removeAttribute('hidden');
					[...contentContainers]
						.filter((c) => c !== contentContainer)
						.forEach((c) => {
							c.hidden = true;
						});
				});
			});

			// Paginare
			contentContainers.forEach((contentContainer) => {
				const navContainer = contentContainer.querySelector('.nj-pagination');
				const pageContainer = contentContainer.querySelector('.has-pagination');
				if (navContainer && pageContainer) {
					let currentPage = Number(pageContainer.dataset.currentPage);
					const totalPages = Number(pageContainer.dataset.totalPages);
					const prevBtn = navContainer.querySelector('.prev-page');
					const nextBtn = navContainer.querySelector('.next-page');
					const btns = navContainer.querySelectorAll('[data-goto-page]');
					const items = pageContainer.querySelectorAll('[data-page]');

					const updateNav = () => {
						prevBtn && (prevBtn.disabled = currentPage === 1);
						nextBtn && (nextBtn.disabled = currentPage === totalPages);

						const activeBtn = [...btns].find((b) => b.dataset.gotoPage === String(currentPage));

						activeBtn?.setAttribute('aria-current', 'true');
						activeBtn?.closest('.nj-pagination__item')?.classList.add('nj-pagination__item--active');
						[...btns]
							.filter((b) => b !== activeBtn)
							.forEach((btn) => {
								btn.removeAttribute('aria-current');
								btn.closest('.nj-pagination__item')?.classList.remove('nj-pagination__item--active');
							});
					};

					const gotoPage = () => {
						[...items].filter((i) => i.dataset.page === String(currentPage)).forEach((i) => (i.hidden = false));
						[...items].filter((i) => i.dataset.page !== String(currentPage)).forEach((i) => (i.hidden = true));
						updateNav();
						pageContainer.dataset.currentPage = currentPage;
					};

					const nextPage = () => {
						if (currentPage < totalPages) {
							currentPage++;
							gotoPage();
						}
					};

					const prevPage = () => {
						if (currentPage > 1) {
							currentPage--;
							gotoPage();
						}
					};

					prevBtn?.addEventListener('click', prevPage);
					nextBtn?.addEventListener('click', nextPage);
					btns.forEach((btn) => {
						btn.addEventListener('click', () => {
							currentPage = Number(btn.dataset.gotoPage);
							gotoPage();
						});
					});
				}
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', jsonTabs);
	} else {
		jsonTabs();
	}
})();
